import { render, staticRenderFns } from "./sAddPartner.vue?vue&type=template&id=74d966a7"
import script from "./sAddPartner.vue?vue&type=script&lang=js"
export * from "./sAddPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports